var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3ABCA7"
    },
    d: "M44.136,52H8.864C4.245,52,0.5,48.255,0.5,43.636V8.364C0.5,3.745,4.245,0,8.864,0h35.272 C48.755,0,52.5,3.745,52.5,8.364v35.272C52.5,48.255,48.755,52,44.136,52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M44.5,14h-18c-0.552,0-1-0.447-1-1s0.448-1,1-1h18c0.553,0,1,0.447,1,1S45.053,14,44.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M44.5,28h-18c-0.552,0-1-0.447-1-1s0.448-1,1-1h18c0.553,0,1,0.447,1,1S45.053,28,44.5,28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M44.5,42h-18c-0.552,0-1-0.447-1-1s0.448-1,1-1h18c0.553,0,1,0.447,1,1S45.053,42,44.5,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.571,17c-0.209,0-0.42-0.065-0.6-0.2L7.4,13.371c-0.442-0.331-0.531-0.958-0.2-1.399 c0.331-0.441,0.957-0.531,1.4-0.2l3.822,2.866l6.248-7.288c0.359-0.42,0.992-0.468,1.41-0.108c0.419,0.359,0.468,0.99,0.108,1.409 l-6.857,8C13.133,16.881,12.854,17,12.571,17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.571,31c-0.209,0-0.42-0.065-0.6-0.2L7.4,27.371c-0.442-0.331-0.531-0.958-0.2-1.399 c0.331-0.441,0.957-0.531,1.4-0.2l3.822,2.866l6.248-7.288c0.359-0.42,0.992-0.468,1.41-0.108c0.419,0.359,0.468,0.99,0.108,1.409 l-6.857,8C13.133,30.881,12.854,31,12.571,31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.571,45.999c-0.209,0-0.42-0.065-0.6-0.2L7.4,42.37c-0.442-0.331-0.531-0.958-0.2-1.399 c0.331-0.441,0.957-0.531,1.4-0.2l3.822,2.866l6.248-7.287c0.359-0.421,0.992-0.469,1.41-0.108 c0.419,0.359,0.468,0.99,0.108,1.409l-6.857,7.999C13.133,45.88,12.854,45.999,12.571,45.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 33,
    style: {
      fill: "#21AE5E"
    },
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 34.586,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "43.5,52 36.5,45.293 37.976,43.879 43.5,49.172 49.024,43.879 50.5,45.293  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueRecord);
export default __webpack_public_path__ + "static/media/value-record.47ff0e603602fc39f1f501da40699573.svg";
export { ForwardRef as ReactComponent };